import { call, put, takeLatest, fork, all } from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as Func from "../helpers/functions";
import { parseReportListRequestParams } from '../utils/commonUtils';
import * as reportActions from './../actions/reportAction';
import * as reportService from './../services/reportService';
import { get, omit } from 'lodash';
import i18n from '../constants/initLng';
import { message } from 'antd';

function* getSaleReport() {
    yield takeLatest(Types.REPORT_GET_SALE_REPORT_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseReportListRequestParams(action.params || {});
        const result = yield call(reportService.getSaleReports, params);
        yield put(reportActions.setSaleReport(result));
    }, errorHandleReport(Types.REPORT_FAIL)))
}

function* getSaleReportByOrder() {
    yield takeLatest(Types.REPORT_GET_SALE_REPORT_BY_ORDER_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseReportListRequestParams(action.params || {});
        const result = yield call(reportService.getSaleReportsByOrder, params);
        yield put(reportActions.setSaleReportByOrder(result));
    }, errorHandleReport(Types.REPORT_FAIL)))
}

function* getSaleReportBySKU() {
    yield takeLatest(Types.REPORT_GET_SALE_REPORT_BY_SKU_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseReportListRequestParams(action.params || {});
        const result = yield call(reportService.getSaleReportsBySKU, params);
        yield put(reportActions.setSaleReportBySKU(result));
    }, errorHandleReport(Types.REPORT_FAIL)))
}

function* getSaleDetailReportBySKU() {
    yield takeLatest(Types.REPORT_GET_SALE_DETAIL_REPORT_BY_SKU_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseReportListRequestParams(action.params || {});
        const result = yield call(reportService.getSaleDetailReportsBySKU, params);
        yield put(reportActions.setSaleDetailReportBySKU(result));
    }, errorHandleReport(Types.REPORT_FAIL)))
}


function* getVoucherRedeemReport() {
    yield takeLatest(Types.REPORT_VOUCHER_REDEEMTION_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseReportListRequestParams(action.params || {});
        const data = yield call(reportService.getVoucherRedeemtions, params);
        yield put(reportActions.setVoucherRedeemtionReport(data.result, { ...params, ...omit(data, 'result') }));
    }, errorHandleReport(Types.REPORT_FAIL)))
}

function* getVoucherRedeemReportDetail() {
    yield takeLatest(Types.REPORT_VOUCHER_REDEEMTION_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseReportListRequestParams(action.params || {});
        const data = yield call(reportService.getVoucherRedeemtionDetail, params);
        yield put(reportActions.setVoucherRedeemtionReportDetail(data.result, { ...params, ...omit(data, 'result') }));
    }, errorHandleReport(Types.REPORT_FAIL)))
}

function* exportVoucherRedeemtions() {
    yield takeLatest(Types.REPORT_EXPORT_REDEEMTIONS_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseReportListRequestParams(action.params || {});
        const result = yield call(reportService.exportVoucherRedeemtions, params);
        const fileName = result.headers['x-suggestion-filename'];
        const fileType = result.headers['content-type'];
        Func.downloadFile(result.data, fileName, { type: fileType });
        Func.sagaSuccessMessage(action, `${i18n.t('notification.downloadSuccess')}`);
        yield put({ type: Types.REPORT_EXPORT_REDEEMTIONS_SUCCESS });
    }, errorHandleReport(Types.REPORT_EXPORT_REDEEMTIONS_FAIL)))
}

function* getCashFlowReport() {
    yield takeLatest(Types.REPORT_GET_CASH_FLOW_REPORT_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseReportListRequestParams(action.params || {});
        const data = yield call(reportService.getCashFlowReport, params);
        yield put(reportActions.setCashFlowReport(data.result, { ...params, ...omit(data, 'result') }));
    }, errorHandleReport(Types.REPORT_FAIL)))
}

function errorHandleReport(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'report');
}

function* getCollaboratorReport() {
    yield takeLatest(Types.REPORT_GET_COLLABORATOR_REPORT_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseReportListRequestParams(action.params || {});
        const result = yield call(reportService.getCollaboratorReports, params);
        yield put(reportActions.setCollaboratorReport(result));
    }, errorHandleReport(Types.REPORT_FAIL)))
}

function* crossCheckPMS() {
    yield takeLatest(Types.CROSS_CHECK_ACTION, Func.sagaWrapper(function* (action) {
        try {
            const result = yield call(reportService.crossCheckPMS, action.body);
            yield put(reportActions.setCrossCheckPMS(result.data));
            message.success("Cross check PMS thành công");
        } catch (error) {
            yield put(reportActions.setCrossCheckPMS(error.data));
            const errorArr = get(error, 'errors[0].message')
            message.error(errorArr);
        }
    }, errorHandleReport(Types.CROSS_CHECK_FAILED)))
}

function* exportCollaboratorReport() {
    yield takeLatest(Types.REPORT_EXPORT_COLLABORATOR_REPORT_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(reportService.exportCollaboratorReport, action.data);
        downloadFileExcel(result);
        reportSuccessMessage(action, `${i18n.t('notification.downloadSuccess')}`);
        yield put({ type: Types.REPORT_EXPORT_COLLABORATOR_REPORT_SUCCESS });
    }, errorHandleReport(Types.REPORT_EXPORT_COLLABORATOR_REPORT_FAIL)))
}

function* getSaleDetailReportByHotel() {
    yield takeLatest(Types.REPORT_GET_SALE_DETAIL_REPORT_BY_HOTEL_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseReportListRequestParams(action.params || {});
        const result = yield call(reportService.getSaleDetailReportsByHotel, params);
        yield put(reportActions.setSaleDetailReportByHotel(result));
    }, errorHandleReport(Types.REPORT_FAIL)))
}

function downloadFileExcel(result) {
    const fileName = result.headers['x-suggestion-filename'];
    const fileType = result.headers['content-type'];
    Func.downloadFile(result.data, fileName, { type: fileType });
}

function reportSuccessMessage(action, message, description) {
    return Func.sagaSuccessMessage({ action, message, description })
}

function* getBtbOrderReport() {
    yield takeLatest(Types.REPORT_GET_BTB_ORDER_REPORT_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseReportListRequestParams(action.params || {});
        const result = yield call(reportService.getBtbOrderReports, params);
        yield put(reportActions.setBtbOrderReport(result));
    }, errorHandleReport(Types.REPORT_FAIL)))
}

function* exportBtbOrderReport() {
    yield takeLatest(Types.REPORT_EXPORT_BTB_ORDER_REPORT_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(reportService.exportBtbOrderReports, action.data);
        downloadFileExcel(result);
        reportSuccessMessage(action, `${i18n.t('notification.downloadSuccess')}`);
        yield put({ type: Types.REPORT_EXPORT_BTB_ORDER_REPORT_SUCCESS });
    }, errorHandleReport(Types.REPORT_EXPORT_BTB_ORDER_REPORT_FAIL)))
}

function* getBtbUseRoomReport() {
    yield takeLatest(Types.REPORT_GET_BTB_USE_ROOM_REPORT_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseReportListRequestParams(action.params || {});
        const result = yield call(reportService.getBtbUseRoomReports, params);
        yield put(reportActions.setBtbUseRoomReport(result));
    }, errorHandleReport(Types.REPORT_FAIL)))
}

function* exportBtbUseRoomReport() {
    yield takeLatest(Types.REPORT_EXPORT_BTB_USE_ROOM_REPORT_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseReportListRequestParams(action.data || {});
        const result = yield call(reportService.exportBtbUseRoomReports, params);
        downloadFileExcel(result);
        reportSuccessMessage(action, `${i18n.t('notification.downloadSuccess')}`);
        yield put({ type: Types.REPORT_EXPORT_BTB_USE_ROOM_REPORT_SUCCESS });
    }, errorHandleReport(Types.REPORT_EXPORT_BTB_USE_ROOM_REPORT_FAIL)))
}

export function* reportSaga() {
    yield all([
        fork(getSaleReport),
        fork(getSaleReportByOrder),
        fork(getSaleReportBySKU),
        fork(getVoucherRedeemReport),
        fork(getVoucherRedeemReportDetail),
        fork(exportVoucherRedeemtions),
        fork(getCashFlowReport),
        fork(getSaleDetailReportBySKU),
        fork(getCollaboratorReport),
        fork(crossCheckPMS),
        fork(exportCollaboratorReport),
        fork(getSaleDetailReportByHotel),
        fork(getBtbOrderReport),
        fork(exportBtbOrderReport),
        fork(getBtbUseRoomReport),
        fork(exportBtbUseRoomReport),
    ])
}
